import { render, staticRenderFns } from "./Arrondi2.vue?vue&type=template&id=6d6f639b&scoped=true"
import script from "./Arrondi2.vue?vue&type=script&lang=js"
export * from "./Arrondi2.vue?vue&type=script&lang=js"
import style0 from "./Arrondi2.vue?vue&type=style&index=0&id=6d6f639b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6f639b",
  null
  
)

export default component.exports